import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import {
  BreadcrumsIcon,
} from "../../SvgIconsData";

import { useNavigate } from "react-router-dom";
import CoursesCard from "./user/courses/CoursesCard";
import Skeleton from "react-loading-skeleton";

const ExploreCoursesHome = ({ screenSize, atHome }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const isLoggedIn = userData.token.length > 0 ? true : false;
  const navigate = useNavigate();
  const [exploreList, setExploreList] = useState([]);
  const [loading, setLoading] = useState(true);
  const tileCards = [{}, {}, {}, {}];

  const getExploreModuleList = async () => {
    let courseSize = { limit: 8 };
    if (screenSize === "large") {
      courseSize = { limit: 12 };
    }
    else if (screenSize === "medium") {
      courseSize = { limit: 8 };
    }
    else if (screenSize === "small") {
      courseSize = { limit: 6 };
    }
    else {
      courseSize = { limit: 4 };
    }

    try {
      setLoading(true)
      const { data } = await axios.get(`${configData.config.API_URL}/api/module/all/${configData.config.MODE}`, {
        params: {...courseSize, applicationId : configData.config.applicationId},
        headers: {
          Authorization: `Bearer`, // Add your bearer token here
        },
      });
      setExploreList(data.data);
    } catch (error) {
      console.log(error);
    }
    setLoading(false)
  };


  useEffect(() => {
    getExploreModuleList();
  }, [isLoggedIn, screenSize]);

  return (
    <>
      <div className="explore-courses">
        <div className="container">
          <div className="row">
            <div className="col-12 mt-2 px-4">
              {!loading ? (
                <CoursesCard list={exploreList} page="explore" atHome={atHome} />
              ) : (
                <div className="courses-parent">
                  <div className="course-tiles">
                    {tileCards.map((e, index) => (
                      <div className="tilecard" key={index}>
                        <div className="course-card">
                          <div className="projectthumb">
                            <Skeleton height={120} />
                          </div>
                          <div className="card-body-main">
                            <Skeleton />
                          </div>
                          <div className="card-body-des">
                            <Skeleton />
                          </div>
                          <div className="devicelist">
                            <Skeleton width={25} height={25} circle />
                            <Skeleton width={25} height={25} circle />
                            <Skeleton width={25} height={25} circle />
                          </div>
                          <div className="card-footer p-1 ">
                            <div className="row">
                              <div className="col-12 p-0 px-2">
                                <Skeleton width={100} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              <div className="col-12 d-flex align-items-center justify-content-end">
                <p className="view-more" onClick={() => navigate('/explore')}>
                  View More ...
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default ExploreCoursesHome;
